import { required } from "@vuelidate/validators";

import Unidade from "./unidade";

export default class SubUnidade {

    constructor() {
        this.id = null;
        this.descricao = null;
        this.unidade = new Unidade();
    }

    validations() {
        return {
            descricao: {
                required,
            },
            unidade: {
                id: {
                    required,
                }
            },
        };
    }
}